const translations = {
  "en": {
    "Portfolio": "Portfolio"
  },
  "zh-tw": {
    "Portfolio": "投資組合"
  }
};

export default translations;
